import { render, staticRenderFns } from "./POC.vue?vue&type=template&id=c91b6a9c&lang=pug"
import script from "./POC.vue?vue&type=script&lang=js"
export * from "./POC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports